// extracted by mini-css-extract-plugin
export default {"value":"ProjectInfo_value__+V7VO","wrapper":"ProjectInfo_wrapper__TXDMN"};